import React from "react";
import { Search, X } from "lucide-react";
import DataManagerDispatchDatePickerInput from "./DataManagerDispatchDatePickerInput.jsx";

const PRIMARY_ACTION_CLASS_NAME = "inline-flex h-8 items-center gap-1 rounded-full bg-accent px-2.75 text-[11px] font-semibold text-white transition-colors duration-150 hover:bg-accent-strong disabled:cursor-not-allowed disabled:opacity-60";
const SECONDARY_ACTION_CLASS_NAME = "inline-flex h-8 items-center gap-1 rounded-full border border-slate-200 bg-white px-2.75 text-[11px] font-semibold text-slate-700 transition-colors duration-150 hover:border-slate-300 hover:text-slate-950 disabled:cursor-not-allowed disabled:opacity-60";
const PANEL_PICKER_INPUT_CLASS_NAME = "h-9 w-full appearance-none rounded-sm border border-slate-200 bg-white py-2 pl-3 pr-8 text-[12px] text-slate-700 outline-hidden transition-colors duration-150 focus:border-accent [&::-webkit-calendar-picker-indicator]:pointer-events-none [&::-webkit-calendar-picker-indicator]:opacity-0";
const PANEL_PICKER_BUTTON_CLASS_NAME = "absolute inset-y-0 right-0 flex w-8 items-center justify-center rounded-r-sm border-l border-slate-200 bg-slate-50 text-slate-500 transition-colors duration-150 hover:text-slate-700 disabled:cursor-not-allowed disabled:text-slate-300";

export default function DataManagerOrdersBrowserDialog({
  browserDeliveryDate = "",
  canApplyBrowserFilters = false,
  dispatchDateSummary = "",
  onApplyBrowserFilters = null,
  onBrowserDeliveryDateChange = null,
  onClearBrowserFilters = null,
  onClose = null,
  totalOrderCount = 0,
}) {
  return (
    <div className="fixed inset-0 z-80 px-4 py-5">
      <button
        type="button"
        aria-label="Fermer la recherche secondaire des commandes"
        className="absolute inset-0 bg-slate-950/45"
        onClick={onClose}
      />
      <div role="dialog" aria-modal="true" aria-label="Recherche secondaire des commandes" className="relative mx-auto max-h-[calc(100dvh-2.5rem)] w-full max-w-2xl overflow-hidden rounded-[4px] border border-black/10 bg-white shadow-[0_24px_70px_rgba(15,23,42,0.22)]">
        <div className="flex items-start justify-between gap-3 border-b border-slate-200 px-4 py-3">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-500">Recherche secondaire</p>
            <h3 className="mt-1 text-[1rem] font-semibold tracking-[-0.02em] text-slate-950">Ouvrir un sous-ensemble ciblé de commandes</h3>
            <p className="mt-1 text-[11.5px] leading-5 text-slate-600">
              Choisissez une date de livraison pour basculer hors dispatch courant. Utilisez ensuite la barre de recherche principale pour affiner.
            </p>
          </div>
          <button type="button" onClick={onClose} className={SECONDARY_ACTION_CLASS_NAME}>
            <X size={13} />
            Fermer
          </button>
        </div>

        <div className="grid gap-3 px-4 py-4">
          <label className="grid max-w-[14rem] gap-1.5">
            <span className="text-[9px] font-semibold uppercase tracking-[0.14em] text-slate-500">Date de livraison</span>
            <DataManagerDispatchDatePickerInput
              buttonClassName={PANEL_PICKER_BUTTON_CLASS_NAME}
              inputClassName={PANEL_PICKER_INPUT_CLASS_NAME}
              onChange={(event) => onBrowserDeliveryDateChange?.(event.target.value)}
              placeholder="jj-mm-aaaa"
              popoverPositioning="floating"
              value={browserDeliveryDate}
            />
          </label>

          <div className="rounded-[14px] border border-slate-200 bg-slate-50/80 px-3 py-2.5 text-[11px] leading-5 text-slate-600">
            <p>Dispatch courant: {dispatchDateSummary}.</p>
            <p className="mt-1">Choisissez une date pour cibler un lot précis, ou laissez vide pour ouvrir toutes les commandes avec la recherche principale.</p>
          </div>

          <div className="flex flex-wrap items-center justify-between gap-2 border-t border-slate-200 pt-3">
            <span className="text-[10.5px] text-slate-500">
              {totalOrderCount} commande(s) disponibles dans le Data Manager
            </span>
            <div className="flex flex-wrap items-center gap-1.5">
              <button type="button" onClick={onClearBrowserFilters} className={SECONDARY_ACTION_CLASS_NAME}>
                Effacer
              </button>
              <button
                type="button"
                onClick={onApplyBrowserFilters}
                disabled={!canApplyBrowserFilters}
                className={PRIMARY_ACTION_CLASS_NAME}
              >
                <Search size={13} />
                Afficher les commandes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
